import { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import api from "@/lib/api";
import LiveChat from "@/pages/LiveChat";
import AIDaughter from "@/pages/AIDaughter";
import GameHelp from "@/pages/GameHelp";
import Economy from "@/pages/Economy";
import Games from "@/pages/Games";
import Music from "@/pages/Music";
import Commands from "@/pages/Commands";
import MediaRedeems from "@/pages/MediaRedeems";
import Sing from "@/pages/Sing";
import Minecraft from "@/pages/Minecraft";
import Avatar from "@/pages/Avatar";
import Moderation from "@/pages/Moderation";
import OverlayInfo from "@/pages/OverlayInfo";
import OverlayLayoutEditor from "@/pages/OverlayLayoutEditor";
import TwitchConnect from "@/pages/TwitchConnect";

export default function Dashboard() {
  const [section, setSection] = useState("chat");
  useEffect(() => { api.post("/config/base-url", { url: window.location.origin }).catch(() => {}); }, []);
  return (
    <div className="dark min-h-screen bg-background text-foreground flex">
      <Sidebar section={section} setSection={setSection} />
      <main className="flex-1 min-w-0 md:pl-64" data-testid="main-content">
        <div className="max-w-[1500px] mx-auto p-4 md:p-8">
          {section === "chat" && <LiveChat />}
          {section === "ai" && <AIDaughter />}
          {section === "gamehelp" && <GameHelp />}
          {section === "economy" && <Economy />}
          {section === "games" && <Games />}
          {section === "music" && <Music />}
          {section === "commands" && <Commands />}
          {section === "redeems" && <MediaRedeems />}
          {section === "sing" && <Sing />}
          {section === "minecraft" && <Minecraft />}
          {section === "avatar" && <Avatar />}
          {section === "moderation" && <Moderation />}
          {section === "overlay" && <OverlayInfo />}
          {section === "overlayedit" && <OverlayLayoutEditor />}
          {section === "twitch" && <TwitchConnect />}
        </div>
      </main>
    </div>
  );
}
